(function(){
  function key(u){
    var v=u.searchParams.get('view');
    return (u.pathname.replace(/\/+$/,'')||'/')+(v?'?view='+v:'');
  }
  function mark(){
    var here=new URL(location.href), p=key(here);
    document.querySelectorAll('.navbar a[href], .s-navbar a[href], .footer a[href]').forEach(function(a){
      try{
        var u=new URL(a.href,location.origin); if(u.origin!==location.origin) return;
        var q=key(u);
        var cur = q===p || (q!=='/' && q.indexOf('?')<0 && p.indexOf(q+'/')===0);
        if(cur){a.classList.add('w--current');a.setAttribute('aria-current','page')}
      }catch(e){}
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mark); else mark();
})();
